import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { Button } from '@components/Button';
import { Text } from '@components/typography';
import { themeColor, themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';
import { Typewriter } from '@sections/chat-gpt/components/TypewriterText/TypewriterText';
import { InterFontFamily, SmallTextStyles } from '@components/typography/interVariants';

export const HEADER_HEIGHT = '1rem';

export const StyledSection = styled(Flex)`
  justify-content: space-around;
`;

export const StyledFlex = styled(Flex)`
  width: 100%;
  ${themeMediaQuery('sm')} {
    width: 50%;
    height: calc(100vh - ${HEADER_HEIGHT});
    overflow-y: auto;
  }
`;

export const StyledText = styled(Text)`
  margin: auto;
  max-width: 392px;
  font-family: ${InterFontFamily};
`;

export const Title = styled(Text)`
  margin: auto;
  max-width: 442px;
  font-size: 56px;
  line-height: 68px;
  margin-bottom: ${themeSpace(7)};
  ${themeMediaQuery('below_sm')} {
    font-size: 48px;
    line-height: 62px;
  }
`;

export const ResponseWrapper = styled(Flex)`
  width: 50%;
  ${themeMediaQuery('below_sm')} {
    top: 0;
    position: fixed;
    z-index: 100;
    width: 100%;
    height: calc(100vh - (100vh - 100%));

    &.slide_hide {
      display: none;
    }

    &.slide_up {
      animation: slide-up 0.9s cubic-bezier(0.65, 0, 0.35, 1) both;
    }

    &.slide_down {
      animation: slide-down 0.9s cubic-bezier(0.65, 0, 0.35, 1) both;
    }

    @keyframes slide-up {
      0% {
        transform: translateY(100vh);
      }
      100% {
        transform: translateY(0);
      }
    }

    @keyframes slide-down {
      0% {
        transform: translateY(0);
      }
      100% {
        transform: translateY(100vh);
        display: none;
      }
    }
`;

export const ResponseComponent = styled(StyledFlex)`
  display: inline;
  width: 100%;
  background-color: ${themeColor('neutra1')};

  ${themeMediaQuery('below_sm')} {
    height: calc(100vh - (100vh - 100%));
    overflow-y: auto;    
    html {
      overflow: hidden;
    }
  }
}
`;

export const ResponseContainer = styled(Box)`
  max-width: 525px;
  ${themeMediaQuery('lg')} {
    max-width: 66%;
  }
`;

export const ResponseText = styled(Typewriter)`
  ${themeVariant('hed32Mobile')};
  line-height: 46px;
`;

export const CloseButton = styled(Button)<{ isClosed?: boolean }>`
  z-index: 102;
  padding: 8px;
  outline: unset !important;
  color: unset;
  line-height: 24px;
  height: 40px;
  width: 40px;
  background: rgba(255, 255, 255, 0.3);
  border: none;
  top: 0;
  right: 0;
  position: absolute;
  display: none;
  margin: ${themeSpace(5)};
  &:hover,
  &:active {
    background-color: rgba(255, 255, 255, 0.3);
  }
  ${themeMediaQuery('below_sm')} {
    display: flex;
  }
`;

export const CopyText = styled(Text)`
  margin-left: ${themeSpace(3)};
  ${SmallTextStyles};
`;

export const CopyButton = styled(Button)`
  background-color: transparent;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  margin-bottom: ${themeSpace(6)};

  :hover {
    background-color: transparent;
    svg,
    ${CopyText} {
      color: ${themeColor('neutra3')};
    }
  }
  :active {
    background-color: transparent;
    svg,
    ${CopyText} {
      color: ${themeColor('neutra5')};
    }
  }
}
`;
